var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Stream in field"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6fabe6",
    d: "M47 3.8v5s-11.35-.8-12.5 3c-1.5 5 10 10 1 21S12 45.05 5 45a38.44 38.44 0 0 1-4-.21v-18s23.5-.11 20.5-11.11C19 6.54 30 .8 47 3.8z",
    opacity: 1,
    "data-original": "#6fabe6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#82bcf4",
    d: "M47 5.24V8.8s-11.35-.8-12.5 3c-1.5 5 10 10 1 21S12 45.05 5 45a18.78 18.78 0 0 1 13.19-18.15c4.74-1.53 8.64-4.27 7.31-9.16C23.2 9.28 32.31 3.75 47 5.24z",
    opacity: 1,
    "data-original": "#82bcf4"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#5b9ad8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 40.94c-1.89 0-2.15-1-3.33-1s-1.46 1-3.34 1-2.14-1-3.33-1a1 1 0 0 1 0-2c1.92 0 2.12 1 3.33 1s1.45-1 3.34-1 2.14 1 3.33 1a1 1 0 0 1 0 2zM18.59 32c-1.89 0-2.15-1-3.34-1s-1.45 1-3.33 1-2.14-1-3.33-1a1 1 0 0 1 0-2c1.88 0 2.13 1 3.33 1s1.44-1 3.33-1 2.15 1 3.34 1a1 1 0 0 1 0 2zM25.75 37c-1.89 0-2.15-1-3.34-1s-1.41 1-3.33 1-2.14-1-3.33-1a1 1 0 0 1 0-2c1.91 0 2.11 1 3.33 1s1.45-1 3.33-1 2.15 1 3.34 1a1 1 0 0 1 0 2zM31.14 28.4c-1.89 0-2.15-1-3.34-1s-1.45 1-3.33 1-2.14-1-3.33-1a1 1 0 0 1 0-2c1.88 0 2.13 1 3.33 1s1.44-1 3.33-1 2.15 1 3.34 1a1 1 0 0 1 0 2z",
    fill: "#5b9ad8",
    opacity: 1,
    "data-original": "#5b9ad8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1 27.8c6 0 16.76-1.45 20.4-6.23S19.53 13.4 24 8.51C27.76 4.39 36.51 3 46.83 4.78a1 1 0 0 0 .34-2C36 .84 26.8 2.47 22.52 7.16a9 9 0 0 0-2 8.8C22.63 23.61 8.89 25.74 1 25.8a1 1 0 0 0 0 2z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.07 7.8c-2-.15-12.21-.67-13.53 3.71-1.75 5.85 9.81 10.11 1.19 20.65C23.13 46.34 1.34 43.83 1.12 43.8a1 1 0 0 0-.24 2 41.6 41.6 0 0 0 4.67.2c7.36 0 21.69-1.55 30.72-12.59 9.33-11.4-2-17.25-.81-21.35.63-2.11 7.08-2.61 11.47-2.29a1 1 0 0 0 .14-1.97z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.85 38.58a4 4 0 0 0-4.37 0 2 2 0 0 1-2.3 0C2.89 37.81 1 37.52 1 38.94a1 1 0 0 0 1 1 1.8 1.8 0 0 1 1.15.36 4 4 0 0 0 4.36 0 2 2 0 0 1 2.31 0c1.27.76 3.18 1.07 3.18-.36a1 1 0 0 0-1-1 1.86 1.86 0 0 1-1.15-.36zM15.25 31c1.18 0 1.45 1 3.34 1a1 1 0 0 0 0-2c-1.18 0-1.45-1-3.34-1s-2.14 1-3.33 1-1.45-1-3.33-1a1 1 0 0 0 0 2c1.17 0 1.45 1 3.33 1s2.14-1 3.33-1zM15.75 36c1.17 0 1.45 1 3.33 1s2.13-1 3.33-1 1.45 1 3.34 1a1 1 0 0 0 0-2c-1.18 0-1.45-1-3.34-1s-2.13 1-3.33 1-1.46-1-3.33-1a1 1 0 0 0 0 2zM29 27.75c1.27.77 3.18 1.08 3.18-.35a1 1 0 0 0-1-1A1.91 1.91 0 0 1 30 26a4 4 0 0 0-4.36 0 2 2 0 0 1-2.3 0c-1.28-.77-3.18-1.07-3.18.36a1 1 0 0 0 1 1 1.87 1.87 0 0 1 1.15.35 4 4 0 0 0 4.36 0 2 2 0 0 1 2.33.04z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiver);
export default __webpack_public_path__ + "static/media/river.c72a81d44cfb5b1e0b07a91c2901fa2a.svg";
export { ForwardRef as ReactComponent };